/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data does a radar chart need?`)
};

const es_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos necesita un gráfico de radar?`)
};

const de_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten benötigt ein Radardiagramm?`)
};

const nl_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke data heeft een radardiagram nodig?`)
};

const fr_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles données un diagramme radar nécessite-t-il ?`)
};

const it_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che dati servono per un grafico radar?`)
};

const pt_br2_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados um gráfico de radar precisa?`)
};

const pt_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados precisa um gráfico radar?`)
};

const ja_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーダーチャートにはどのようなデータが必要ですか？`)
};

const zh_radar_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雷达图需要什么数据？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_faq_q1", locale)
	if (locale === "en") return en_radar_faq_q1(inputs)
	if (locale === "es") return es_radar_faq_q1(inputs)
	if (locale === "de") return de_radar_faq_q1(inputs)
	if (locale === "nl") return nl_radar_faq_q1(inputs)
	if (locale === "fr") return fr_radar_faq_q1(inputs)
	if (locale === "it") return it_radar_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_radar_faq_q1(inputs)
	if (locale === "pt") return pt_radar_faq_q1(inputs)
	if (locale === "ja") return ja_radar_faq_q1(inputs)
	return zh_radar_faq_q1(inputs)
};